module.exports = __webpack_public_path__ + "site_static/img/data-1.437c9ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneimg/data-1.jpg
// module id = C+gu
// module chunks = 0